import { getCurrentConsumer, setCurrentConsumer } from '../internals/consumer.js';
import { getCurrentScope } from '../internals/contexts.js';
import { createReactiveSignal } from '../internals/reactive.js';
import { generatorResultToPromiseWithConsumer } from '../internals/generators.js';
export function isGeneratorFunction(fn) {
    return (typeof fn === 'function' && fn.constructor?.name === 'GeneratorFunction');
}
export function isAsyncFunctionWithoutTransform(fn) {
    return typeof fn === 'function' && fn.constructor?.name === 'AsyncFunction';
}
/**
 * Wrap a Babel-transformed async generator in a real `async function` that drives it
 * with {@link generatorResultToPromiseWithConsumer}. Used on the server (RSC + SSR)
 * where hooks-based Suspense replay is not appropriate.
 */
export function createServerAsyncComponentWrapper(fn) {
    return async function (props) {
        const scope = getCurrentScope();
        const owned = createReactiveSignal({ compute: () => null, equals: () => true, isRelay: false, tracer: undefined }, [], undefined, scope);
        return generatorResultToPromiseWithConsumer(fn(props), owned);
    };
}
/**
 * Wrap a sync render function with consumer/scope tracking. Used by the server
 * `component()` for non-generator definitions.
 */
export function createServerSyncComponentWrapper(fn) {
    return function (props) {
        const scope = getCurrentScope();
        const owned = createReactiveSignal({ compute: () => null, equals: () => true, isRelay: false, tracer: undefined }, [], undefined, scope);
        const prevConsumer = getCurrentConsumer();
        try {
            setCurrentConsumer(owned);
            return fn(props);
        }
        finally {
            setCurrentConsumer(prevConsumer);
        }
    };
}
